import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'
import { REDUCER_NAME } from './const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const CHANGE_TABLE_SETTING = NS + 'CHANGE_TABLE_SETTING'

export const UPLOAD_CUSTOMER_FILE_REQUEST = NS + 'UPLOAD_CUSTOMER_REQUEST'
export const UPLOAD_CUSTOMER_FILE_SUCCESS = NS + 'UPLOAD_CUSTOMER_FILE_SUCCESS'
export const UPLOAD_CUSTOMER_FILE_ERROR = NS + 'UPLOAD_CUSTOMER_FILE_ERROR'

export const SET_DELETE_FLAG_REQUEST = NS + 'SET_DELETE_FLAG_REQUEST'
export const SET_DELETE_FLAG_SUCCESS = NS + 'SET_DELETE_FLAG_SUCCESS'
export const SET_DELETE_FLAG_ERROR = NS + 'SET_DELETE_FLAG_ERROR'



// WEBPACK FOOTER //
// ./src/modules/customer/state/cbct-file-upload/type.js